// src/ConsumerApp/api/products/product.service.js
import { apiClient } from '../apiClient';

export const ProductService = {
  /**
   * 1. Get Selling Products
   */
  getSellingProducts: async ({
    customer_id,
    product_category_id,
    attribute_value_ids,
    search_string,
    page = 1,
    page_size = 20,
  }) => {
    const params = new URLSearchParams({
      customer_id: customer_id || '',
      product_category_id: product_category_id || '',
      page: String(page),
      page_size: String(page_size),
    });

    if (search_string) {
      params.append('search_string', search_string);
    }

    if (attribute_value_ids && attribute_value_ids.length > 0) {
      params.append('attribute_value_ids', attribute_value_ids.join(','));
    }

    const response = await apiClient.get(
      `/brickbucket/product/get-selling-products?${params.toString()}`
    );
    return response.data || response;
  },

  /**
   * 2. Add Item to Bucket[cite: 4]
   */
  addItemToBucket: async (payload) => {
    const response = await apiClient.post('/brickbucket/bucket/add-item-to-bucket', {
      customer_id: payload.customer_id,
      item_id: payload.item_id,
      purchase_type: payload.purchase_type, // "BUY_NOW" | "RFQ"[cite: 4]
      quantity: payload.quantity,
    });
    return response.data || response;
  },

  /**
   * 3. Update Bucket Item Quantity[cite: 4]
   */
  updateBucketItemQuantity: async (payload) => {
    const response = await apiClient.put('/brickbucket/bucket/update-bucket-item-quantity', {
      customer_id: payload.customer_id,
      item_id: payload.item_id,
      purchase_type: payload.purchase_type,
      quantity: payload.quantity,
    });
    return response.data || response;
  },

  /**
   * 4. Get Bucket Summary[cite: 4]
   */
  getBucketSummary: async (customer_id) => {
    const response = await apiClient.get(
      `/brickbucket/bucket/get-bucket-summary?customer_id=${customer_id}`
    );
    return response.data || response;
  },

  /**
   * 5. Get Bucket Items and Bill Summary[cite: 4]
   */
  getBucketItemsAndBillSummary: async ({ customer_id, purchase_type, delivery_address_id }) => {
    const params = new URLSearchParams({
      customer_id: customer_id || '',
      purchase_type: purchase_type || 'BUY_NOW',
    });
    if (delivery_address_id) {
      params.append('delivery_address_id', delivery_address_id);
    }
    const response = await apiClient.get(
      `/brickbucket/bucket/get-bucket-items-and-bill-summary?${params.toString()}`
    );
    return response.data || response;
  },

  /**
   * 6. Delete Bucket Item
   */
  deleteBucketItem: async (data) => {
    const response = await apiClient.delete('/brickbucket/bucket/delete-bucket-item', {
      data,
    });
    return response.data || response;
  },

  /**
   * 7. Get Product by ID[cite: 9]
   */
  getProductById: async (id) => {
    const response = await apiClient.get(`/brickbucket/product/get-product?id=${id}`);
    return response.data || response;
  },

  /**
   * 8. Get Product Variants
   */
  getProductVariants: async (product_id, purchase_mode = 'Buy Now') => {
    const response = await apiClient.get(
      `/brickbucket/product/get-product-variants-by-product-id?product_id=${product_id}&purchase_mode=${purchase_mode}`
    );
    return response.data || response;
  },

  /**
   * 9. Get FAQs by Product Sub-Category ID[cite: 9]
   */
  getFaqsBySubCategoryId: async (subcategoryId) => {
    const response = await apiClient.get(
      `/brickbucket/product-sub-category/get-faqs-by-pscId?product_sub_category_id=${subcategoryId}`
    );
    return response.data || response;
  },

  /**
   * 10. Get Products by Category IDs[cite: 9]
   */
  getProductsByCategoryIds: async (categoryIds) => {
    const response = await apiClient.post('/brickbucket/product/get-products-by-category-ids', {
      categoryIds,
    });
    return response.data || response;
  },

  /**
   * 11. Get Filters By Category
   */
  getFiltersByCategory: async (categoryId) => {
    const response = await apiClient.get(
      `/brickbucket/product-attributes/get-filters-by-category?product_category_id=${categoryId}`
    );
    return response.data || response;
  },

  /**
   * 12. Get Most Searched Products
   */
  getMostSearchedProducts: async () => {
    const response = await apiClient.get('/brickbucket/product/get-most-searched-products');
    return response.data || response;
  },

  /**
   * 13. Get Similar Products
   */
  getSimilarProducts: async ({ customer_id, product_id }) => {
    const response = await apiClient.get(
      `/brickbucket/product/get-similar-products?customer_id=${customer_id || ''}&product_id=${product_id}`
    );
    return response.data || response;
  },

  /**
   * 14. Get Related Products
   */
  getRelatedProducts: async ({ customer_id, product_id }) => {
    const response = await apiClient.get(
      `/brickbucket/product/get-related-products?customer_id=${customer_id || ''}&product_id=${product_id}`
    );
    return response.data || response;
  },
};